import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=2a5e8276&"
import script from "./loader.js?vue&type=script&lang=ts&"
export * from "./loader.js?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports